import { SwipeableDrawer } from "@mui/material"
import { Puller } from "./Puller"

interface IBottomSheetProps {
  children: React.ReactNode,
  isOpen: boolean,
  handleOpen: () => void,
  handleClose: () => void,
  height?: number
}

const drawerBleeding = 56;

export const BottomSheet = ({ children, isOpen, handleOpen, handleClose, height }: IBottomSheetProps) => {
  const container = () => window.document.querySelector("#root");
  return (
    <SwipeableDrawer
      container={container}
      swipeAreaWidth={drawerBleeding}
      anchor="bottom"
      disableSwipeToOpen
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      slotProps={{ paper: { style: { background: 'none' } } }}
    >
      <div style={{ height: `${height ?? 70}vh`, overflow: "hidden", borderTopLeftRadius: 16, borderTopRightRadius: 16, background: 'white' }}>
        <Puller />
        <div style={{ width: "100%", height: 48 }}></div>
        <div style={{ padding: 16, paddingBottom: 128, overflow: "auto", maxHeight: "100%" }}>
          {children}
        </div>
      </div>
    </SwipeableDrawer>
  )
}
